import { queryKeyFactory } from "@l2r-front/l2r-query"

export const DAMAGES_ROOT_QUERY_KEY = "damages"

export const damagesQueryKeys = queryKeyFactory(DAMAGES_ROOT_QUERY_KEY, {
    layer: (filters = {}) => [DAMAGES_ROOT_QUERY_KEY, "layer", filters] as const,
    stats: (filters = {}) => [DAMAGES_ROOT_QUERY_KEY, "stats", filters] as const,
    types: (filters = {}) => [DAMAGES_ROOT_QUERY_KEY, "types", filters] as const,
})
